import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var generateStyle = function generateStyle(componentTheme, props) {
  return {
    stem: {
      display: 'flex',
      flexWrap: 'wrap',
      alignItems: 'center',
      fontSize: componentTheme.stemFontSize
    },
    root: {
      margin: "0 ".concat(componentTheme.rootMargin),
      paddingTop: componentTheme.rootPadding
    },
    feedbackWrapper: {
      margin: "0 ".concat(componentTheme.feedbackWrapperMargin)
    },
    blank: _objectSpread(_objectSpread({}, !props.richFITB && {
      display: 'flex',
      alignItems: 'center',
      margin: "0 ".concat(componentTheme.feedbackWrapperMargin)
    }), props.richFITB && {
      display: 'inline-block'
    }),
    incorrectFeedbackWrapper: {
      paddingTop: componentTheme.incorrectFeedbackWrapperPadding
    },
    userResponse: {
      paddingRight: componentTheme.userResponsePadding,
      whiteSpace: 'pre-wrap'
    }
  };
};
export default generateStyle;